module.exports = __webpack_public_path__ + "media/images/svgs/alert-ea2f24434d38db1c102c85000f284987.svg";